// Pipe to combine filter input and multiple options selection box at catalogues page.
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'singleSelectionPipe'
})

export class SharedSingleSelectionPipe implements PipeTransform {
    transform(items: any[], inputValue:string, selectedBrands:any[], allSelected:any, filteSource:string) {


        let newResult = [];
        let filterBySelectedResult: any[] = [];
        let filterByInputResult = [];
        let filterResult: any[] = [];

        if(!items) return [];
        if(!selectedBrands) {
            return items;
        };

        switch(filteSource){
            // Filter for catalogues page. 
            case 'catalogues': {
                //The selction value will be checked agaignst brand only
                if(this.checkingArr(selectedBrands)){
                    for(let brand of selectedBrands){
                        newResult =  items.filter( it => {
                            if(it.brand.toLowerCase() === brand.toLowerCase()){
                                return it;
                            }
                        });  
                        if(typeof filterBySelectedResult !== 'undefined' && filterBySelectedResult.length > 0 ){
                            filterBySelectedResult = filterBySelectedResult.concat(newResult)
                        }else if( newResult.length > 0){
                            filterBySelectedResult = newResult;
                        }
                    }
                }

                //The Input Value will be checked against brand and title
                if(inputValue){
                    filterByInputResult =  items.filter( it => {
                        if( it.brand.toLowerCase().includes(inputValue.toLowerCase()) ){
                            return it;
                        }else if( it.title.toLowerCase().includes(inputValue.toLowerCase()) ){
                            return it;
                        }
                    });
                }
                
                break;
            }
            default: {
                //statements; 
                break;
            }
        }

        if(typeof filterResult == "undefined"){
            return "";
        }


        if(inputValue.length != 0 && this.checkingArr(selectedBrands)){
            //console.log('join result');
            filterResult = this.intersection_destructive(filterByInputResult, filterBySelectedResult);
        }else if(inputValue.length != 0){
            //console.log('filterByInputResult');
            filterResult = filterByInputResult;
        }else if(this.checkingArr(selectedBrands)){
            //console.log('filterBySelectedResult');
            filterResult = filterBySelectedResult;
        }

        if(allSelected && ( inputValue.length == 0 || !this.checkingArr(selectedBrands) )) {
            //If user type a keyword and return none. + Auto deselect the options. 
            if(inputValue.length !== 0 && !this.checkingArr(filterByInputResult)){
            }else{
                return items;
            }
        };


        if(inputValue.length == 0 && !this.checkingArr(selectedBrands)){
            return items;
        }else if(this.checkingArr(filterResult)){
            return filterResult;
        }else {
            //console.log('no filter result');
            return [];
        }

    }


    checkingArr(array:any[]):boolean{
        if(typeof array != "undefined" && array != null){
            if(array.length != null && array.length > 0){
                return true;
            }
            return false;
        }else{
            return false;
        }
    }

    intersection_destructive(a:any[], b:any[]):any{
        if( typeof a !== "undefined" &&  typeof b !== "undefined"){
            let result:any[] = [];
            a.forEach(elementInA => {
                b.forEach(elementInB => {
                    if(elementInA.newsId == elementInB.newsId){
                        result.push(elementInA);
                    }
                    // else{
                    //     console.log("not matched result");
                    // }
                });
            });
            if(result.length > 0){
                return result;
            }else{
                return [];
            }
        }

    }

}